<template>
  <div class="intro-wrapper">
    <div class="intro-left">
      <h1>关于我们</h1>
      <p>
        天目里 杭州 (2013-2020)总建筑面积约 23
        万平方米，这是伦佐·皮亚诺建筑工作室在中国的第一个作品。
        这里是集办公空间、艺术空间、实验剧场、目里百货、设计酒店、独特商业集合等多元业态为一体的新概念综合体，汇集艺术、建筑、设计、创意、自然、文化领域的从业者和公司，向往或已经沉浸在这些领域的都市人，与其说它是一处地方，不如说它是各种可能性。这里就像一座小城，有上千人工作和生活的地方，从商业到艺术、设计、时尚、文化，各种各样的事在这里发生。这里共有17个单体建筑，通过围合的方式创造出一个中心广场，称之为“城市客厅”，包容着中央花园、经典的水镜广场和乔木树阵，同时又对地块进行切割，创造出广场与城市之间的连接和渗透，为故事的发生营造了空间，也为空间预留了故事的可能。
      </p>
    </div>
    <img :src="require('@/assets/intro.png')" alt="" class="intro-right" />
  </div>
</template>

<script>
export default {
  setup() {
    return {};
  },
};
</script>

<style lang="less" scoped>
.intro-wrapper {
  display: flex;
  justify-content: center;
  align-items: center;
  background-color: #f2f2f2;
  height: 750px;
  background-image: url("~@/assets/intersect.png");
  background-size: 98px 98px;
  .intro-left {
    width: 580px;
    h1 {
      height: 34px;
      font-size: 24px;
      font-weight: 500;
      color: rgba(0, 0, 0, 0.8999999761581421);
      line-height: 28px;
    }
    p {
      margin-top: 16px;
      font-size: 16px;
      font-weight: 400;
      color: rgba(0, 0, 0, 0.6000000238418579);
      line-height: 24px;
    }
  }
  .intro-right {
    width: 261px;
    height: 369px;
    margin-left: 138px;
  }
}
</style>
